import { dlog } from "corexxx";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { DHook } from "../libs/common_hooks/DHook";
import { SimpleStoreClient } from "../libs/common_ts/SimpleStoreClient";
import { DefaultAccountScreen } from "../libs/components/screens/DefaultAccountScreen";
import { DefaultPageInProgress } from "../libs/components/screens/DefaultPageInProgress";
import {
  TAppConfig,
  setAppConfig,
  useDAppCommand,
} from "../libs/dweb/DAppCommand";
import { DAppInit } from "../libs/dweb/DAppInit";
import { DAppWrapper } from "../libs/dweb/DAppWrapper";
import { DHelmet } from "../libs/dweb/DHelmet";
import { DPageLoadingWrapper } from "../libs/dweb/DPageLoadingWrapper";
import { LandingPage } from "./LandingPage";

// Step1: Init
let appConfig: TAppConfig = {
  app_id: "grodok_home",
  app_name: "Grodok Home",
  primary_color: "#1e88e5",
  app_slogan: "-",
  app_subtext: "-",
  logo: require("./focus/favicon_io/android-chrome-512x512.png"),
};
SimpleStoreClient.Get().init(appConfig);
setAppConfig(appConfig);


function App() {
  return (
    <RecoilRoot>
      <DHelmet config={{ page_title: "Grodok" }} />
      <DAppWrapper>
        <BrowserRouter>
          <DAppInit appConfig={appConfig} />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<DefaultPageInProgress />} />
          </Routes>
        </BrowserRouter>
      </DAppWrapper>
    </RecoilRoot>
  );
}

export default App;
